import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TSLogoDark } from "../../../Routes/ImagePath";
import Footer from "../../layout/Footer";
import * as Yup from "yup";
import axios from "axios";
import {  
  getApiUrl,
} from "../../../utils/AuthUtils";
const ForgotPassword = () => {
  const entityLogo = localStorage.getItem("entity_logo");
  const entityName = localStorage.getItem("entity_name");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  // Yup schema for email validation
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage("");
    setErrorMessage("");

    try {
      // 1. Validate input
      // await validationSchema.validate({ email }, { abortEarly: false });

      // 2. API call
      setLoading(true);
      const res = await axios.post(
        `${getApiUrl()}/api/forgot-password`,
        { email }
      );
      if(res.data.success){        
        setMessage(res.data.message || "Password reset link sent to your email");
      } else {
        setErrorMessage(res.data.message);
      }
    } catch (err) {
      if (err.name === "ValidationError") {
        // Yup validation errors
        const validationErrors = {};
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        setErrors(validationErrors);
      } else if (err.response) {
        // API errors
        setErrorMessage(err.response.data.message || "Something went wrong");
      } else {
        setErrorMessage("Network error. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-page">
      <div className="main-wrapper">
        <div className="account-content">
          <div className="container">
            <div className="account-logo">
              <img src={entityLogo} />
            </div>
            <div className="account-box">
              <div className="account-wrapper">
                <h2 className="account-title">
                  {entityName && (
                    <h2 className="account-title">{entityName}</h2>
                  )}
                </h2>
                <h3 className="account-title">Forgot Password?</h3>
                <p className="account-subtitle">
                  Enter your email to get a password reset link
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="input-block">
                    <label>Email Address</label>
                    <input
                      className="form-control"
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>
                  <div className="input-block text-center">
                    <button
                      className="btn btn-primary account-btn"
                      type="submit"
                    >
                     {loading ? "Sending..." : "Reset Password"}
                    </button>
                  </div>
                  {message && (
                    <div className="alert alert-info mt-3">{message}</div>
                  )}
                  {errorMessage && (
                    <div className="alert alert-danger mt-3">{errorMessage}</div>
                  )}
                  <div className="account-footer">
                    <p>
                      Remember your password? <Link to="/login">Login</Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgotPassword;
